import { ReactElement } from "react";
import NetworkMint from "../../components/NetworkMint/Steps/Mint";
import MintLayout from "../../components/Layouts/Mint";
import { Wizard } from "react-use-wizard";
import CodeWord from "../../components/NetworkMint/Steps/CodeWord";
import Play from "../../components/NetworkMint/Steps/Play";
import SEO from "../../components/Seo/Seo";
const Network = () => {
  return (
    <>
      <SEO title="Network Mint | Coinage Media" />
      <section className="flex items-center justify-center py-12">
        <Wizard>
          <CodeWord />
          <Play />
          <NetworkMint />
        </Wizard>
      </section>
    </>
  );
};

Network.getLayout = function getLayout(page: ReactElement) {
  return (
    <MintLayout middleElementClassName="order-3 tab:order-[inherit] w-full tab:w-auto">
      {page}
    </MintLayout>
  );
};

export default Network;
